import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { ProSidebarProvider } from "react-pro-sidebar";
import "bootstrap-icons/font/bootstrap-icons.css";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";
import { Provider } from "react-redux";
import LoadingPage from "./component/LoadingPage";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Suspense fallback={<LoadingPage />}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <ProSidebarProvider>
            <App />
          </ProSidebarProvider>
        </Router>
      </PersistGate>
    </Provider>
  </Suspense>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
